import React, { useState, useCallback } from "react";

import {
  TextField,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
  Button,
  Paper,
  Grid,
  Select,
  MenuItem,
  Theme
} from "@material-ui/core";

import playgroundTheme from "./theme";
import BigLabelTextField from "./BigLabelTextField";

const defaultTheme = createMuiTheme();

const useStyles = makeStyles(theme => ({
  page: {
    width: "100vw",
    height: "100vh",
    padding: theme.spacing(2)
  }
}));

const themes: Record<string, Theme> = {
  playground: playgroundTheme,
  default: defaultTheme
};

const StylePlayground: React.FC<{}> = () => {
  const [theme, _setTheme] = useState({
    name: "playground",
    theme: playgroundTheme
  });
  const setTheme = useCallback(
    (t: string) => _setTheme({ name: t, theme: themes[t] }),
    []
  );
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme.theme}>
      <Paper>
        <div className={classes.page}>
          <Grid
            direction="column"
            justify="center"
            alignItems="center"
            spacing={1}
            container
          >
            <Grid
              item
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={1}
            >
              <Select
                value={theme.name}
                onChange={ev => setTheme(ev.target.value as string)}
              >
                <MenuItem value={"playground"}>Playground theme</MenuItem>
                <MenuItem value={"default"}>Default theme</MenuItem>
              </Select>
            </Grid>
            <Grid
              item
              container
              direction="row"
              justify="center"
              alignItems="center"
              spacing={1}
            >
              <Grid
                xs={3}
                container
                direction="column"
                alignItems="center"
                justify="center"
                spacing={2}
                item
              >
                <Grid item container>
                  <BigLabelTextField fullWidth label="First Name" />
                </Grid>
                <Grid item container>
                  <BigLabelTextField fullWidth label="Last Name" />
                </Grid>
                <Grid item container>
                  <BigLabelTextField fullWidth label="Billing Address" />
                </Grid>
              </Grid>
              <Grid item>
                <TextField label="MUI Label" />
              </Grid>
              <Grid item>
                <Button>Activate</Button>
              </Grid>
              <Grid item>
                <Button variant="outlined">Regenerate</Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" color="secondary">
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </ThemeProvider>
  );
};

export default StylePlayground;
